module.exports = "/_next/static/images/bhp-cf4d4ed3d9bfef5a46dac7e0df9c490c.jpg";